
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

export function insertPaper (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/paper',
    method: 'POST',
    data: parameter
  })
}
export function updatePaper (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/paper',
    method: 'PUT',
    data: parameter
  })
}
export function deletePaper (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/paper',
    method: 'DELETE',
    params: parameter
  })
}
export function getPaperList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/papers',
    method: 'GET',
    params: parameter
  })
}
export function getPaperInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/paper',
    method: 'GET',
    params: parameter
  })
}
// 试卷下载 paperDownload
export function paperDownload (name) {
  return axios({
    url: sysInfo.apiRemote + `/paper/${name}`,
    responseType: 'blob',
    method: 'GET'
  })
}
